import { enEnviroment } from 'interfaces/enviroment';

// Accounts
export const ACCOUNT_ENV = process.env.REACT_APP_ACCOUNT_ENV;
export const ACCOUNT_PARTNER = process.env.REACT_APP_ACCOUNT_PARTNER;

// Admin v3
export const ADMIN_URL_NEW = process.env.REACT_APP_ADMIN_URL_NEW || 'https://sun-admin.eduzz.com';

// Analytics Google
export const GTAG_ID = process.env.REACT_APP_GTAG_ID;

// API Endpoint
export const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT || 'https://adminsunapi.eduzz.com';

// APP Configs
export const ENV = process.env.REACT_APP_ENV || enEnviroment.PROD;
export const SNACKBAR_DEFAULT_TIMEOUT = 3000;

// CDN
export const CDN_URL = process.env.REACT_APP_CDN_URL || 'https://cdn.testzz.ninja';
export const ERROR_IMAGE = `${CDN_URL}/sun/admin/default-product-img.svg`;

// Checkout V3 URL
export const SUN_URL = process.env.REACT_APP_SUN_URL || 'https://sun.eduzz.com';

// Checkout Elements URL
export const CHK_URL = process.env.REACT_APP_CHK_URL || 'https://chk.eduzz.com';

// Orbita URL
export const ORBITA_URL = process.env.REACT_APP_ORBITA_URL || 'https://orbita.eduzz.com';

// FIDC
export const API_ENDPOINT_FIDC = process.env.REACT_APP_API_ENDPOINT_FIDC || 'https://fidc-agreement-api.eduzz.com';

// Sentry
export const SENTRY_KEY = process.env.REACT_APP_SENTRY_KEY;
